import React from "react";
import { Typography } from "components";
import PrimaryRoles from "./PrimaryRoles";
import SecondaryRoles from "./SecondaryRoles";

import "../style.scss";

const ManageRoles = () => {
  return (
    <div className="role-management-container pt-4">
      <Typography state="primary" component="h4" variant="subtitle3">
        All Available Roles
      </Typography>
      <Typography variant="caption1">
        Below are the available User types on the system.
      </Typography>
      <PrimaryRoles />
      <SecondaryRoles />
    </div>
  );
};

export default ManageRoles;
